import Component from '../../components/component/component';
import AjaxPage from '../ajax/ajax-page';

import './plan.scss';

interface IPlanSettings {
    houseSelector: string;
}

export default class Plan extends Component {
    static initSelector: string = '.plan';

    houses: JQuery;
    settings: IPlanSettings;

    constructor(target: HTMLElement) {
        super(target);

        this.settings = {
            houseSelector: '.plan__house',
        };

        this.houses = this.element.find(this.settings.houseSelector);

        this.init();
    }

    init(): void {
        this.houses.on('click', this.onClick.bind(this));
    }

    onClick(event: JQuery.ClickEvent): void {
        const target: JQuery = $(event.currentTarget);
        const url: string = target.data('href');

        if (gotoAndPlay.ajax.isEnabled) {
            AjaxPage.changePage(url);
        } else {
            window.location = target.data('href');
        }
    }
}
